import {useParams, useSearchParams} from "react-router-dom";
import TableTitle from "../../../common/list/components/TableTitle";
import React, {useEffect, useState} from "react";
import ToolBarEmployeeContract from "./extra/ToolBarEmployeContract";
import {Button, Card, Col, Empty, message, Modal, Pagination, Row, Select, Table} from "antd";
import {DG_Format_Money} from "../../../format/money";
import {ArrowDownOutlined, ArrowUpOutlined} from "@ant-design/icons";
import {columns} from "./columns/columns";
import {getReportCompare, getReportNow} from "../../../api/report";
import moment from "moment";
import {createReport, deleteWeightSlip, deleteWeightSlips, getAllWeightSlipsUi} from "../../../api/weightSlip";
import {t} from "i18next";
import {KeyConstant} from "./constant/keyConstant";
import Report from "./report/report";
import {useSelector} from "react-redux";
import EditParent from "./model/editParent";
import {mapMoney} from "./common/mapMoney";
import SockJS from "sockjs-client";
import {BASE_PATH} from "../../../custom/axios/config/Url";
import Stomp from "stompjs";
import {getMe} from "../../../api/system/admin/user-account";
import ViewParent from "../report/modal/viewParent";
import deleteImg from "../../../asset/icon/delete.png";
import ModalAddParent from "./component/modalAddParent";

const styleColor = {
    color: "#98A2B3",
    fontsize: 16,
    fontWeight: 400
}

const styleColor1 = {
    color: "#344054",
    fontWeight: 600,
    fontsize: 18
}

const styleBorderBottom = {
    borderBottom: "1px solid #EAECF0",
    padding: "8px 0"
}

const styleColor2 = {
    fontWeight: 400,
    fontsize: 16,
}

const styleColor3 = {
    color: "#101828",
    fontWeight: 600,
    marginRight: 5
}

const stylePercentIncrease = {
    color: "#12B76A",
    marginLeft: 10,
    fontWeight: 600,
}
const stylePercentReduction = {
    color: "#F04438",
    marginLeft: 10,
    fontWeight: 600,
}

const styleCol = {
    // paddingTop : 8,
    borderRight: "1px solid #EAECF0"
}

const styleRowPadding = {
    paddingLeft: 24,
    cursor: "pointer"
}

const styleRowPaddingBG = {
    paddingLeft: 24,
    backgroundColor: "#F2F4F7",
    cursor: "pointer",
    color: "#0065D9"
}

var stompClient = null

const WeighingSlip = () => {

    const height = window.innerHeight;
    const headerFilter = document.getElementById('header-filter')?.clientHeight
    const cardReport = document.getElementById('card-report')?.clientHeight
    const {code} = useParams()
    const [dataSource, setDatasource] = useState()
    const [dataNow, setDataNow] = useState()
    const [dataCompare, setDataCompare] = useState()
    const [type, setType] = useState("bill")
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(20)
    const [total, setTotal] = useState(0)
    const [searchParams] = useSearchParams()
    const [reloadReport, setReloadReport] = useState(false)
    const {weighingStation} = useSelector(state => state.permissionAccountActionReducer)
    const {reloadData} = useSelector(state => state.layoutInteractionReducer)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [reloadData1, setReloadData] = useState(false);
    const [check, setCheck] = useState(true);
    const [visible, setVisible] = useState()
    const [id, setId] = useState()
    const [name, setName] = useState()
    const [refresh, setRefresh] = useState()
    const me = getMe();
    const [title, setTitle] = useState()
    const [visibleReport, setVisibleReport] = useState(false)
    const [idReport, setIdReport] = useState()
    const [nameReport, setNameReport] = useState()
    const [idDelete, setIdDelete] = useState()

    useEffect(() => {
        const socket1 = new SockJS(`${BASE_PATH}/public/dogoo/ws-message`);
        stompClient = Stomp.over(socket1);
        stompClient.connect({}, function (frame) {
            stompClient.subscribe("/public/dogoo/messages", function (greeting) {
                let data = JSON.parse(greeting.body)
                if (data.databaseKey === code) {
                    setRefresh(data.date)
                }
            });
        });
    }, [code])

    const mapDatasource = (data) => {
        if (!data) {
            return [];
        }
        return data?.map((item) => {
            return {
                key: item.weightSlipId,
                ...item,
                ngayCan: <>
                    <span> {moment(item.ngayCan).format("DD/MM/YYYY")} </span> -
                    <span> {moment(item.gioKTai).parseZone().format("HH:mm")} </span>
                </>,
                thanhTien: DG_Format_Money(item.thanhTien),
                // donGia: DG_Format_Money(item.donGia),
                hang: DG_Format_Money(item.hang),
                menu: <> {
                    item.permission &&
                    <img src={deleteImg}
                         className={"cursor-pointer"}
                         title={"Xóa"}
                         onClick={() => {
                             setIsModalVisible(true)
                             setIdDelete(item.weightSlipId)
                         }}
                         alt={deleteImg}/>
                } </>
            };
        });
    }

    useEffect(() => {
        let ws = weighingStation.filter(item => item.weighingStationCode === code)
        setTitle(ws[0]?.weighingStationName)
    }, [weighingStation, code])

    useEffect(() => {
        getReportNow(code).then(r => {
            setDataNow(r)
        })
            .catch(() => {
            })

        let dateStart = searchParams.get("startDate") ? moment(searchParams.get("startDate")).toDate() :
            moment().subtract(28, "days").toDate()
        let dateEnd = searchParams.get("endDate") ? moment(searchParams.get("endDate")).toDate() :
            moment().subtract(1, "days").toDate()

        let startDate = moment(dateStart);
        let endDate = moment(dateEnd);
        let startDateAxios = moment(dateStart);
        let endDateAxios = moment(dateEnd);
        let startDateCompare = null
        let endDateCompare = null

        let compare = searchParams.get("compare") ? searchParams.get("compare") : false
        let compareType = searchParams.get("compareType") ? searchParams.get("compareType") : "previousPeriod"
        let type = searchParams.get("type") ? searchParams.get("type") : KeyConstant.THIRTY_DAYS_AGO
        if (compare) {
            let dateDiff = endDate.diff(startDate, 'days') + 1
            if (compareType === "previousPeriod") {
                switch (type) {
                    case KeyConstant.TODAY:
                    case KeyConstant.YESTERDAY:
                        startDateCompare = startDate.subtract(1, "days").format("YYYY-MM-DDTHH:mm:ss")
                        endDateCompare = endDate.subtract(1, "days").format("YYYY-MM-DDTHH:mm:ss")
                        break;
                    case KeyConstant.THIS_WEEK:
                    case KeyConstant.LAST_WEEK:
                        startDateCompare = startDate.subtract(1, "weeks").startOf("week").format("YYYY-MM-DDTHH:mm:ss")
                        endDateCompare = endDate.subtract(1, "weeks").endOf("week").format("YYYY-MM-DDTHH:mm:ss")
                        break;
                    case KeyConstant.THIS_MONTH:
                    case KeyConstant.LAST_MONTH:
                        startDateCompare = moment(startDate).subtract(1, "months").startOf("month").format("YYYY-MM-DDTHH:mm:ss")
                        endDateCompare = moment(startDate).subtract(1, "months").endOf("month").format("YYYY-MM-DDTHH:mm:ss")
                        break;
                    case KeyConstant.SEVEN_DAYS_AGO:
                        startDateCompare = startDate.subtract(7, "days").format("YYYY-MM-DDTHH:mm:ss")
                        endDateCompare = endDate.subtract(7, "days").format("YYYY-MM-DDTHH:mm:ss")
                        break;
                    case KeyConstant.THIRTY_DAYS_AGO:
                        startDateCompare = startDate.subtract(30, "days").format("YYYY-MM-DDTHH:mm:ss")
                        endDateCompare = endDate.subtract(30, "days").format("YYYY-MM-DDTHH:mm:ss")
                        break;
                    case KeyConstant.NINETY_DAYS_AGO:
                        startDateCompare = startDate.subtract(90, "days").format("YYYY-MM-DDTHH:mm:ss")
                        endDateCompare = endDate.subtract(90, "days").format("YYYY-MM-DDTHH:mm:ss")
                        break;
                    default :
                        startDateCompare = startDate.subtract(dateDiff, "days").format("YYYY-MM-DDTHH:mm:ss")
                        endDateCompare = endDate.subtract(dateDiff, "days").format("YYYY-MM-DDTHH:mm:ss")
                        break;
                }
            } else if (compareType === "periodLastYear") {
                startDateCompare = startDate.subtract(1, "years").format("YYYY-MM-DDTHH:mm:ss")
                endDateCompare = endDate.subtract(1, "years").format("YYYY-MM-DDTHH:mm:ss")
            }
        }

        getReportCompare(code, startDateAxios.format('YYYY-MM-DDTHH:mm:ss'),
            endDateAxios.format('YYYY-MM-DDTHH:mm:ss'), startDateCompare, endDateCompare).then(r => {
            setDataCompare(r)
        })
            .catch(() => {
            })
    }, [reloadData, refresh, code, searchParams])

    useEffect(() => {
        getAllWeightSlipsUi(code, page - 1, pageSize, searchParams.getAll('soXe'),
            searchParams.getAll('tenHang'), searchParams.getAll('khachHang'),
            searchParams.get("startDate") ? moment(searchParams.get("startDate")).format('YYYY-MM-DDTHH:mm:ss') :
                moment().subtract(28, "days").format('YYYY-MM-DDTHH:mm:ss'),
            searchParams.get("endDate") ? moment(searchParams.get("endDate")).format('YYYY-MM-DDTHH:mm:ss') :
                moment().subtract(1, "days").format('YYYY-MM-DDTHH:mm:ss'),
            searchParams.get('search')).then(r => {
            if (r.totalElements !== total) setPage(1)
            setDatasource(mapDatasource(r.content))
            setTotal(r.totalElements)
            setCheck(r.content.length > 0 ? r.content[0].permission : true)
        })
            .catch(() => {
            })
        setSelectedRowKeys([])
    }, [page, pageSize, reloadData, reloadData1, refresh, code, searchParams, total])
    const exportData = () => {

        let array = weighingStation.filter(item => item.weighingStationCode === code)
        let name = array[0].weighingStationName.replaceAll(" ", "")

        const fileName = moment().format("HHmm_DDMMYYYY");

        let dateStart = searchParams.get("startDate") ? moment(searchParams.get("startDate")).toDate() :
            moment().subtract(28, "days").toDate()
        let dateEnd = searchParams.get("endDate") ? moment(searchParams.get("endDate")).toDate() :
            moment().subtract(1, "days").toDate()

        const startDate = moment(dateStart).format("DDMMYYYY");
        const endDate = moment(dateEnd).format("DDMMYYYY");

        createReport(code, searchParams.getAll('soXe'),
            searchParams.getAll('tenHang'), searchParams.getAll('khachHang'), dateStart, dateEnd,
            searchParams.get("search"), fileName + "_Baocao" + name + "_" + startDate + "-" + endDate).then(r => {
            setVisibleReport(true)
            setIdReport(r.id)
            setNameReport(r.name)
        })
            .catch(() => {
            })

    }

    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const handleOk = () => {
        if (idDelete) {
            deleteWeightSlip(idDelete, me.key, code, "deletedTemp").then(r => {
                message.info("Xóa được đưa vào hàng đợi hệ thống đồng bộ")
                setReloadData(!reloadData1)
                setIsModalVisible(false)
            })
                .catch(() => {
                    message.error("Hệ thống đang gặp sự cố")
                })
        } else {
            let s = selectedRowKeys.join("&id=")
            deleteWeightSlips("?id=" + s, me.key, code, "deletedTemp").then(r => {
                message.info("Xóa được đưa vào hàng đợi hệ thống đồng bộ")
                setReloadData(!reloadData1)
                setIsModalVisible(false)
            })
                .catch(() => {
                    message.error("Hệ thống đang gặp sự cố")
                })
        }
    }

    const handleOkDeleted = () => {
        if (idDelete) {
            deleteWeightSlip(idDelete, me.key, code, "deleted").then(r => {
                message.info("Xóa được đưa vào hàng đợi hệ thống đồng bộ")
                setReloadData(!reloadData1)
                setReloadReport(!reloadReport)
                setIsModalVisible(false)
            })
                .catch(() => {
                    message.error("Hệ thống đang gặp sự cố")
                })
        } else {
            let s = selectedRowKeys.join("&id=")
            deleteWeightSlips("?id=" + s, me.key, code, "deleted").then(r => {
                message.info("Xóa được đưa vào hàng đợi hệ thống đồng bộ")
                setReloadData(!reloadData1)
                setReloadReport(!reloadReport)
                setIsModalVisible(false)
            })
                .catch(() => {
                    message.error("Hệ thống đang gặp sự cố")
                })
        }
    }

    const mapHeaderTable = () => {
        return (
            <Row>
                <Col span={12}>
                    {
                        selectedRowKeys.length > 0 && check &&
                        <Button type="primary" style={{color: "white"}}
                                onClick={() => setIsModalVisible(true)}>
                            Xóa
                        </Button>
                    }
                </Col>
                <Col span={12} className={"flex justify-end items-center"}>
                    {
                        total > 0 && <Pagination simple
                                                 showTotal={(total, range) => `${range[0]}-${range[1]} trong số ${total}`}
                                                 pageSize={pageSize}
                                                 current={page}
                                                 total={total}
                                                 className={"flex text-center items-center"}
                                                 showQuickJumper
                                                 onChange={(page) => setPage(page)}/>
                    }
                    {
                        total > 0 &&
                        <div className={"customer_select_page"}>
                            <Select
                                defaultValue={pageSize}
                                options={[
                                    {value: 20, label: 20},
                                    {value: 30, label: 30},
                                    {value: 50, label: 50},
                                    {value: 100, label: 100},
                                ]}
                                size={"small"}
                                onChange={(value) => setPageSize(value)}
                                style={{
                                    width: 60
                                }}
                            />
                        </div>
                    }
                </Col>
            </Row>
        )
    }

    const footer = () => {
        return (
            <>
                <Button key="back" onClick={() => setIsModalVisible(false)}>
                    Hủy
                </Button>
                <Button key="submit"
                        type="primary"
                        style={{color: "white"}}
                        onClick={handleOk}>
                    Xóa tại trạm
                </Button>
                <Button key="submitReport"
                        type="primary"
                        style={{color: "white"}}
                        onClick={handleOkDeleted}>
                    Xóa vĩnh viễn
                </Button>
            </>
        )
    }

    return (
        <div className={"h-full overflow-hidden"}>
            <TableTitle
                title={title}
                // title={"Tổng quan nhanh về báo cáo"}
                extra={<ToolBarEmployeeContract
                    code={code}
                    exportData={exportData}/>}
                check={true}
            />

            <div className={"overflow-y-hidden overflow-x-hidden h-full bg-white customer_scroll"}>
                <div className={"bg-white"} id={"card-report"}>
                    <Row className={"p-6"} gutter={24}>
                        <Col span={17}>
                            <Card
                                className={"custom_home_card h-full"}
                                bodyStyle={{
                                    padding: 0
                                }}
                            >
                                <Row>
                                    <Col span={7} style={styleCol}>
                                        <Row style={type === "bill" ? styleRowPaddingBG : styleRowPadding}
                                             onClick={() => setType("bill")}>
                                            <Col span={24} className={"pt-2 h-8"}>
                                                <span style={styleColor2}> Phiếu xuất </span>
                                            </Col>
                                            <Col span={24}
                                                 className={"flex justify-start items-center h-8 mb-2 mt-1.5"}>
                                                <span
                                                    style={{...styleColor3, fontSize: 30}}> {dataCompare?.bill} </span>
                                                <span style={styleColor}> (phiếu) </span>
                                                {
                                                    dataCompare && dataCompare?.billPercent !== 0 &&
                                                    <>
                                                        {
                                                            dataCompare?.billPercent > 0 ?
                                                                <span style={stylePercentIncrease} className={"flex"}>
                                                            <ArrowUpOutlined/> {dataCompare?.billPercent}%
                                                        </span> :
                                                                <span style={stylePercentReduction} className={"flex"}>
                                                            <ArrowDownOutlined/> {Math.abs(dataCompare?.billPercent)}%
                                                        </span>
                                                        }
                                                    </>
                                                }
                                            </Col>
                                        </Row>
                                        <Row style={type === "netWeight" ? styleRowPaddingBG : styleRowPadding}
                                             onClick={() => setType("netWeight")}>
                                            <Col span={24} className={"pt-2 h-8"}>
                                                <span style={styleColor2}> Khối lượng  </span>
                                            </Col>
                                            <Col span={24} style={styleColor1}
                                                 className={"flex justify-start items-center h-8 mb-2 mt-1.5"}>
                                                    <span style={{
                                                        ...styleColor3,
                                                        fontSize: 30
                                                    }}>
                                                        {DG_Format_Money(dataCompare?.netWeight / 1000 || 0)}
                                                    </span>
                                                <span style={styleColor}> (tấn) </span>
                                                {
                                                    dataCompare && dataCompare?.netWeightPercent !== 0 &&
                                                    <>
                                                        {
                                                            dataCompare?.netWeightPercent > 0 ?
                                                                <span style={stylePercentIncrease} className={"flex"}>
                                                            <ArrowUpOutlined/> {dataCompare?.netWeightPercent}%
                                                        </span> :
                                                                <span style={stylePercentReduction} className={"flex"}>
                                                            <ArrowDownOutlined/> {Math.abs(dataCompare?.netWeightPercent)}%
                                                        </span>
                                                        }
                                                    </>
                                                }
                                            </Col>
                                        </Row>
                                        <Row style={type === "revenue" ? styleRowPaddingBG : styleRowPadding}
                                             onClick={() => setType("revenue")}>
                                            <Col span={24} className={"pt-2 h-8"}>
                                                <span style={styleColor2}> Doanh thu  </span>
                                            </Col>
                                            <Col span={24} style={styleColor1}
                                                 className={"flex justify-start items-center h-8 mb-2 mt-1.5"}>
                                                {
                                                    mapMoney(dataCompare?.revenue)
                                                }
                                                {
                                                    dataCompare && dataCompare?.revenuePercent !== 0 &&
                                                    <>
                                                        {
                                                            dataCompare?.revenuePercent > 0 ?
                                                                <span style={stylePercentIncrease} className={"flex"}>
                                                            <ArrowUpOutlined/> {dataCompare?.revenuePercent}%
                                                        </span> :
                                                                <span style={stylePercentReduction} className={"flex"}>
                                                            <ArrowDownOutlined/> {Math.abs(dataCompare?.revenuePercent)}%
                                                        </span>
                                                        }
                                                    </>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={17} className={"flex justify-center"}>
                                        <Report code={code} type={type} reloadReport={reloadReport}
                                                refresh={refresh}/>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col span={7}>
                            <Card
                                className={"custom_home_card h-full"}
                                headStyle={{
                                    padding: 10
                                }}
                                bodyStyle={{
                                    padding: "12px 24px"
                                }}
                            >
                                <Row>
                                    <Col span={24} style={styleColor}>
                                        Hôm nay
                                    </Col>
                                </Row>
                                <Row style={styleBorderBottom}>
                                    <Col span={20} className={"h-8 flex items-center"}>
                                        <span style={styleColor1}> Phiếu xuất </span>
                                        <span style={styleColor} className={"ml-1"}> (phiếu) </span>
                                    </Col>
                                    <Col span={4} style={styleColor1} className={"flex justify-end items-center"}>
                                        {dataNow?.bill}
                                    </Col>
                                </Row>
                                <Row style={styleBorderBottom}>
                                    <Col span={20} className={"h-8 flex items-center"}>
                                        <span style={styleColor1}> Khối lượng  </span> <span
                                        style={styleColor} className={"ml-1"}> (tấn) </span>
                                    </Col>
                                    <Col span={4} style={styleColor1} className={"flex justify-end items-center"}>
                                        {dataNow?.netWeight / 1000 || 0}
                                    </Col>
                                </Row>
                                <Row style={styleBorderBottom}>
                                    <Col span={20} className={"h-8 flex items-center"}>
                                        <span style={styleColor1}> Doanh thu  </span> <span
                                        style={styleColor} className={"ml-1"}> (VNĐ) </span>
                                    </Col>
                                    <Col span={4} style={styleColor1} className={"flex justify-end items-center"}>
                                        {DG_Format_Money(dataNow?.revenue)}
                                    </Col>
                                </Row>
                                <Row style={{paddingTop: 8}}>
                                    <Col span={20} className={"h-8 flex items-center"}>
                                        <span style={styleColor1}> Khách hàng  </span> <span
                                        style={styleColor} className={"ml-1"}> (số lượng) </span>
                                    </Col>
                                    <Col span={4} style={styleColor1} className={"flex justify-end items-center"}>
                                        {dataNow?.customer}
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                </div>

                <div className={"bg-white px-6 h-[100%]"}>
                    {
                        dataSource &&
                        <div
                            className={"custom-table relative bg-white rounded-xl overflow-hidden"}
                            style={{
                                border: "1px solid #EAECF0",
                                height: height - headerFilter - cardReport - 25
                            }}>
                            <div className={"h-[100%] overflow-auto customer-table_Weight-split"}>
                                <Table
                                    title={() => mapHeaderTable()}
                                    rowSelection={rowSelection}
                                    columns={columns}
                                    pagination={false}
                                    dataSource={dataSource}
                                    sticky
                                    locale={{
                                        emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                          description={t("common.noData")}/>
                                    }}
                                    onRow={(record) => {
                                        return {
                                            onClick: () => {
                                                if (record.permission) {
                                                    setVisible(true)
                                                    setId(record.weightSlipId)
                                                    setName(record.maPhieu)
                                                }
                                            }
                                        }
                                    }}
                                    scroll={{
                                        y: height - headerFilter - cardReport - 135
                                    }}
                                    rowClassName={`max-h-[64px] h-[48px] overflow-hidden cursor-pointer customer-check-box`}
                                />
                            </div>
                        </div>
                    }

                </div>
            </div>

            <Modal
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                destroyOnClose={true}
                footer={footer()}
            >
                <p>{t("common.message.deleteAsk")}</p>
            </Modal>

            <EditParent visible={visible}
                        id={id}
                        onCancel={() => {
                            setVisible(false)
                            setId(undefined)
                            setName(undefined)
                        }}
                        name={name} databaseKey={code}/>

            <ViewParent visible={visibleReport}
                        id={idReport}
                        databaseKey={code}
                        onCancel={() => {
                            setVisibleReport(false)
                            setIdReport(undefined)
                        }}
                        name={nameReport}/>

            <ModalAddParent databaseKey={code}/>
        </div>
    )
}

export default WeighingSlip
